import React from 'react';
import { plural } from '@lingui/core/macro';

import { Flex, Text } from '@rover/kibble/core';
import StarRating from '@rover/kibble/patterns/StarRating';
import type { ThemeFontWeight } from '@rover/kibble/styles/themeTypes';

type Props = {
  ratingsAverage: string;
  reviewsCount: number;
  fontWeight?: ThemeFontWeight;
};

export default function RatingsReview({
  ratingsAverage,
  reviewsCount,
  fontWeight,
}: Props): React.ReactElement {
  const rating = parseFloat(ratingsAverage) || 0;
  const hasRating = rating > 0;
  const separator = hasRating ? '• ' : '';

  return (
    <Flex gap="2x" data-testid="ratings-review-row">
      {hasRating && (
        <StarRating
          textSize="100"
          fontWeight={fontWeight ?? 'regular'}
          rating={rating}
          variant="compact"
        />
      )}
      <Text size="100" fontWeight={fontWeight ?? 'regular'}>
        {separator}
        {plural(reviewsCount, { one: '# review', other: '# reviews' })}
      </Text>
    </Flex>
  );
}
